var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderLeftDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44465 2.08008C6.75135 2.08008 6.99997 2.3287 6.99997 2.6354L6.99997 14.5248C6.99997 14.8315 6.75135 15.0801 6.44465 15.0801H3.55529C3.24859 15.0801 2.99997 14.8315 2.99997 14.5248L2.99997 2.6354C2.99997 2.3287 3.24859 2.08008 3.55529 2.08008H6.44465Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4447 7.08008C13.7513 7.08008 14 7.3287 14 7.6354V14.5248C14 14.8315 13.7513 15.0801 13.4447 15.0801H10.5553C10.2486 15.0801 9.99997 14.8315 9.99997 14.5248V7.6354C9.99997 7.3287 10.2486 7.08008 10.5553 7.08008H13.4447Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.4969H1.99997",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderLeftDown);
export default ForwardRef;